import { StudentSocialCardComponent } from './student-social-card/student-social-card.component';
import { DataService } from './../../../services/data.service';
import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../../services/common-authentication.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StudentAcademicAdditionalCardComponent } from './student-academic-additional-card/student-academic-additional-card.component';

 
@Component({
  selector: 'app-student-profile-activities',
  templateUrl: './student-profile-activities.component.html',
  styleUrls: ['./student-profile-activities.component.scss']
})
export class StudentProfileActivitiesComponent implements OnInit, OnDestroy {

  @ViewChild('academicAdditional') academicAdditional: StudentAcademicAdditionalCardComponent;

  @Input() studentUserId: number;
  @Input() studentProfileId: number;
  @Input() isStudenFirstLogIn: boolean;

  highSchoolName = '';
  highSchoolListJson = [];
  classRankListJson = [];
  subjectListJson = [];
  yearListJson = [];
  activityData: any;
  othActivityData: any;
  activityTextData: any;
  othActivityTextData: any;
  musicData: any;
  ROTCData: any;
  sportsData: any;
  sportsSecondData = [];
  sportsThirdData = [];
  seeMySelfData: any;
  lyfAboutYouData: any;
  musicTextData: any;
  sportsTextData: any;
  classRank: any;
  currentHighSchoolPlan = [];
  profileData: any = {};
  classRankValue: any;
  highSchoolValue: any;
  nextButtonFlag: any;
  partnerId: any;
  textFlag: any;
  showSort = [false];
  thirdCloseDisableFlag = false;
  studentActivitiesLoader = false;
  userRole: any;
  secondCall = false;
  socialCardFormTouched;
  subscription: Subscription[] = [];
  private destroyed$ = new Subject();

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonService: CommonService,
    private dataService: DataService,
    public router: Router,
    private routes: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.subscription.push(
    this._commonDataSharedService.socialSaveProfile.subscribe((data) => {
      this.socialCardFormTouched = data;
     if (this.academicAdditional.formsTouched || this.socialCardFormTouched) {
      const currentRoute = this.routes.snapshot.url[0].path;
      this._commonDataSharedService.saveModal.next(currentRoute);
      this._commonDataSharedService.duplicateContact.next(true);
     }
    }),

    this._commonDataSharedService.goBackFlag.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data === 'pageThree') {
        this.secondCall = false;
      }
    })
    )
    window.scrollTo(0, 0);
    const localStorageData = this._commonAuthService.getLoginData();
    this.nextButtonFlag = localStorageData.isFirstLogOn;

    this.userRole = localStorageData.role;

    this.textFlag = localStorageData.isFirstLogOn;
    this.getHighSchoolList();
    this.getClassRankList();
    this.getSubjectList();
    this.getYearList();
    this.getProfileData();

    this._commonDataSharedService.studentQuestionaryThreeActivityData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data && data['selectedList']) {
        this.activityData = data['selectedList'];
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeOtherActivityData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data && data['selectedList']) {
        this.othActivityData = data['selectedList'];
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeMusicData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data && data['selectedList']) {
        this.musicData = data['selectedList'];
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeROTCData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data && data['selectedList']) {
        this.ROTCData = data['selectedList'];
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeSportsFirstData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.sportsData = data;
    });

    this._commonDataSharedService.studentQuestionaryThreeSportsSecondData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      const oldDataSecond = data;
      for (let i = 0; i < Object.keys(oldDataSecond).length; i++) {
        this.sportsSecondData.push(oldDataSecond[i]);
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeSportsThirdData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      const oldDataThird = data;
      for (let i = 0; i < Object.keys(oldDataThird).length; i++) {
        this.sportsThirdData.push(oldDataThird[i]);
      }
    });

    this._commonDataSharedService.studentQuestionaryThreeSeeMySelfData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.seeMySelfData = data['seeMyself'];
    });

    this._commonDataSharedService.studentQuestionaryThreelyfAboutYouData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.lyfAboutYouData = data['lyfAboutYou'];
    });

    this._commonDataSharedService.studentQuestionaryThreeOtherActivityTextData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.activityTextData = data['othActivityText'];
    });

    this._commonDataSharedService.studentQuestionaryThreeActivityTextData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.othActivityTextData = data['activityText'];
    });

    this._commonDataSharedService.studentQuestionaryThreeMusicTextData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.musicTextData = data['musicText'];
    });

    this._commonDataSharedService.studentQuestionaryThreeSportsTextData.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.sportsTextData = data;
    });

    this._commonDataSharedService.studentQuestionaryThreeCloseFlag.pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      if (data) {
        this.thirdCloseDisableFlag = true;
      }
    });

    this._commonDataSharedService.studentProfileNavigation.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      if (this.thirdCloseDisableFlag) {
        this._commonService.setDataWithoutObservable(true, 'studentProfileDirty');
      } else {
        this._commonService.setDataWithoutObservable(false, 'studentProfileDirty');
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.subscription.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  saveData() {
    const module = this._commonAuthService.getModule();
        const additionAcademic = this.academicAdditional.getAdditionalData();
        if (this.secondCall) {
          const obj = {
            studentUserId: this.studentUserId.toString(),
            highSchool: additionAcademic.highSchoolName,
            homeSchooled: additionAcademic.homeSchooled,
            onlineHighSchool: additionAcademic.onlineHighSchool,
            classRankClassId: additionAcademic.rankClassId,
            currentHighSchoolPlan: additionAcademic.currentHighSchoolplan || [],
            clubClassIds: this.activityData || [],
            otherClub: this.othActivityTextData || null,
            sportsClassIds: this.sportsData || [],
            otherSport: this.sportsTextData || '',
            musicClassIds: this.musicData || [],
            otherMusic: this.musicTextData ? this.musicTextData : '',
            otherActivitiesClassIds: this.othActivityData || [],
            otherActivity: this.activityTextData || null,
            seeMyself: this.seeMySelfData || '',
            otherInformation: this.lyfAboutYouData || '',
            rotcClassIds: this.ROTCData || [],
            firstCall: !!this.textFlag
          };
          this._commonRequestResponseService.postWithHeader('Student/questionnaire3', obj).subscribe(() => {
            this.notificationService.show('success', 'Profile saved successfully');
            this.secondCall = false;
          }, () => {
            this.notificationService.show('error', 'Error while saving profile data');
            this.secondCall = true;
          });
        }
   
  }

  getHighSchoolList() {
    this.highSchoolListJson = this.dataService.getEntity('High School').item || [];
  }

  getClassRankList() {
    this.classRankListJson = this.dataService.getEntity('Class Rank').item || [];
    this.classRankListJson.sort(this._commonService.dynamicSort('value', true));
  }

  getSubjectList() {
    const subjectListJson = this.dataService.getEntity('Subject').item || [];
    this.subjectListJson = subjectListJson.map(entry => Object.assign(entry, { checkedValue: false }));
  }

  getYearList() {
    const yearListJson = this.dataService.getEntity('Number of Years Elective').item || [];
    this.yearListJson = yearListJson.map((entry, index) => Object.assign(entry, { yearValue: index + 1 }));
  }

  getProfileData() {
    this.studentActivitiesLoader = true;
    const selectedType = {
      studentUserId: this.studentUserId,
      profileId: this.studentProfileId
    };

    this._commonRequestResponseService.postWithHeader('student/getprofile1/', selectedType, ['profileId'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((rawProfileData: any) => {
        rawProfileData = rawProfileData || {};
        this.profileData = rawProfileData.data;
        if (this.profileData) {
          this._commonService.setData(this.profileData);
          this.classRankValue = this.profileData.classRankClassId;
          this.highSchoolName = this.profileData.highSchool;

          if (this.profileData.onlineHighSchool) {
            for (let i = 0; i < this.highSchoolListJson.length; i++) {
              if (this.highSchoolListJson[i].text === 'I attend an Online School') {
                this.highSchoolValue = this.highSchoolListJson[i].id;
              }
            }
          }
          if (this.profileData.homeSchooled) {
            for (let i = 0; i < this.highSchoolListJson.length; i++) {
              if (this.highSchoolListJson[i].text === 'I am Home-Schooled') {
                this.highSchoolValue = this.highSchoolListJson[i].id;
              }
            }
          }
          const highSchoolPlanId = [];
          const yearPlanId = [];
          let currentHighSchoolPlanJSON = [];
          if (this.profileData && this.profileData.currentHighSchoolPlan && this.profileData.currentHighSchoolPlan.length > 0) {
            for (let a = 0; a < this.profileData.currentHighSchoolPlan.length; a++) {
              highSchoolPlanId.push(this.profileData.currentHighSchoolPlan[a].HighSchoolPlanClassID);
              yearPlanId.push(this.profileData.currentHighSchoolPlan[a].Years);
              currentHighSchoolPlanJSON.push({
                highSchoolSubjectClassId: this.profileData.currentHighSchoolPlan[a].HighSchoolPlanClassID,
                years: this.profileData.currentHighSchoolPlan[a].Years
              })
            }
          }
          const subjectListJsonObj = this.subjectListJson;
          const tempArray = [];
          if (subjectListJsonObj && subjectListJsonObj.length) {
            for (let i = 0; i < subjectListJsonObj.length; i++) {
              const obj = {
                id: subjectListJsonObj[i].id,
                text: subjectListJsonObj[i].text
              };
              tempArray.push(obj);
            }
          }
          this.subjectListJson = tempArray;
          if (!currentHighSchoolPlanJSON.length) {
            currentHighSchoolPlanJSON = this.subjectListJson.map((subject) => {
              return {
                highSchoolSubjectClassId: subject.id,
                years: 0
              }
            });
          }
          this.currentHighSchoolPlan = currentHighSchoolPlanJSON;
        }
        this.studentActivitiesLoader = false;
        this.secondCall = true;
      },
        () => {
          this.studentActivitiesLoader = false;
          this.notificationService.show('error', 'Error while fetching west states');
          this.secondCall = false;
        });
  }

  sortTable(orderBy, columnName, order) {
    this.showSort[order] = !this.showSort[order];
    this.subjectListJson.sort(this._commonService.dynamicSort(columnName, false));
  }

}
